<template lang='pug' src='./hero.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { openVideo, openModal } from '@/methods'

export default {
  computed: {
    video () {
      return this.$refs.video
    }
  },
  mounted () {
    this.video.play()
  },
  props: ['props'],
  mixins: [ openVideo, openModal ],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// hero.vue?273bcfdc